import "./ClientRegistrationMedicalHistoryMedicalHistoryComponent.scss";
import * as Yup from "yup";
import React, {useCallback, useEffect, useState} from "react";
import _ from "lodash";
import {Field, FieldProps, Form, Formik, FormikHelpers} from "formik";
import {useDispatch, useSelector} from "react-redux";
import {ImageConfig, Misc} from "../../../../constants";
import {IAPIResponseType} from "../../../../shared/models/api.model";
import FormikTextAreaComponent
    from "../../../../shared/components/form-controls/formik-text-area/FormikTextAreaComponent";
import FormikCheckBoxComponent
    from "../../../../shared/components/form-controls/formik-check-box/FormikCheckBoxComponent";
import {IRootReducerState} from "../../../../store/reducers";
import ButtonComponent from "../../../../shared/components/button/ButtonComponent";
import CheckBoxComponent from "../../../../shared/components/form-controls/check-box/CheckBoxComponent";
import {CommonService} from "../../../../shared/services";
import FormDebuggerComponent from "../../../../shared/components/form-debugger/FormDebuggerComponent";
import {setFormChangesData} from "../../../../store/actions/form-state.action";

interface ClientRegistrationMedicalHistoryMedicalHistoryComponentProps {
    onNext: () => void;
    appointmentId: any
}

// interface OptionListProps {
//     options: Option[];
// }

const ClientMedicalHistoryValidationSchema = Yup.object({
    medical_history: Yup.object({
        isCustomOption: Yup.boolean().nullable(),
        questions: Yup.array().min(0),
        comments: Yup.string().when("isCustomOption", {
            is: true,
            then: Yup.string().required('Comments is required'),
            otherwise: Yup.string().nullable()
        })
    }),
});

const ClientMedicalHistoryInitialValues: any = {
    medical_history: {
        questions: [],
        isCustomOption: false,
        comments: ""
    }
};

const ClientRegistrationMedicalHistoryMedicalHistoryComponent = (props: ClientRegistrationMedicalHistoryMedicalHistoryComponentProps) => {

    const {onNext, appointmentId} = props;
    // const [searchKey, setSearchKey] = useState<string>("");
    const {medicalHistoryOptionsList} = useSelector((state: IRootReducerState) => state.staticData);
    const [clientMedicalHistoryInitialValues, setClientMedicalHistoryInitialValues] = useState<any>(_.cloneDeep(ClientMedicalHistoryInitialValues));
    const dispatch = useDispatch();
    const {
        clientMedicalHistoryDetails,
    } = useSelector((state: IRootReducerState) => state.client);
    const {currentUser} = useSelector((state: IRootReducerState) => state.account);


    // const medicalHistoryOptionsListAlphabetical = medicalHistoryOptionsList?.sort((a, b) => a.title.localeCompare(b.title));
    useEffect(() => {
        if (clientMedicalHistoryDetails) {
            if (clientMedicalHistoryDetails?.medical_history?.comments) {
                clientMedicalHistoryDetails.medical_history.isCustomOption = true;
            }
            setClientMedicalHistoryInitialValues({
                medical_history: clientMedicalHistoryDetails.medical_history || []
            });
        }
    }, [clientMedicalHistoryDetails]);

    const onSubmit = useCallback((values: any, {setErrors, setSubmitting}: FormikHelpers<any>) => {
        const payload = {
            ...CommonService.removeKeysFromJSON(_.cloneDeep(values), ['questions_details']),
            appointment_id: appointmentId ? appointmentId : currentUser?.appointment_id,
            client_id: currentUser?._id,
        };
        setSubmitting(true);
        CommonService._client.ClientMedicalHistoryMedicalHistoryDetailsSaveAPICall(payload)
            .then((response: IAPIResponseType<any>) => {
                CommonService._alert.showToast(response[Misc.API_RESPONSE_MESSAGE_KEY], "success");
                setSubmitting(false);
                dispatch(setFormChangesData(false));
                onNext();
            })
            .catch((error: any) => {
                CommonService.handleErrors(setErrors, error, true);
                setSubmitting(false);
            })
    }, [onNext, currentUser, dispatch, appointmentId]);

    const handleMedicalHistoryOptionSelection = useCallback((optionId: string, selectedOptions: string[]) => {
        const options = _.cloneDeep(selectedOptions);
        const index = options?.findIndex((value: string) => value === optionId);
        if (index > -1) {
            options.splice(index, 1);
        } else {
            options.push(optionId);
        }
        return options;
    }, []);

    // const groupOptionsAlphabetically = (options: Option[]) => {
    //     const groupedOptions: { [key: string]: Option[] } = {};
    //
    //     options.sort((a, b) => a.title.localeCompare(b.title)); // Sort the options alphabetically by title
    //
    //     for (const option of options) {
    //         const firstLetter = option.title[0].toUpperCase(); // Get the first letter of the title and convert to uppercase
    //
    //         if (!groupedOptions[firstLetter]) {
    //             groupedOptions[firstLetter] = [];
    //         }
    //
    //         groupedOptions[firstLetter].push(option);
    //     }
    //
    //     // Remove empty entries from the object
    //     for (const letter in groupedOptions) {
    //         if (groupedOptions[letter].length === 0) {
    //             delete groupedOptions[letter];
    //         }
    //     }
    //
    //     return groupedOptions;
    // }

    const midIndex = Math.ceil(medicalHistoryOptionsList.length / 2);
    const column1 = medicalHistoryOptionsList.slice(0, midIndex);
    const column2 = medicalHistoryOptionsList.slice(midIndex);

    return (
        <div className={'client-registration-medical-history-medical-history-component'}>
            <div className={'client-registration-form-description'}>
                Have you ever had or do you currently have: (Check all that apply)
            </div>
            {/*<div className={'client-registration-medical-history-search'}>*/}
            {/*    <SearchComponent value={searchKey}*/}
            {/*                     onChange={value => setSearchKey(value)}/>*/}
            {/*</div>*/}
            <Formik
                validationSchema={ClientMedicalHistoryValidationSchema}
                initialValues={clientMedicalHistoryInitialValues}
                onSubmit={onSubmit}
                validateOnChange={false}
                validateOnBlur={true}
                enableReinitialize={true}
                validateOnMount={true}>
                {({
                      values,
                      setFieldError,
                      isSubmitting,
                      setFieldTouched,
                      setFieldValue,
                      isValid,
                      validateForm,
                      dirty
                  }) => {
                    // eslint-disable-next-line react-hooks/rules-of-hooks
                    useEffect(() => {
                        validateForm();
                        if (dirty) {
                            dispatch(setFormChangesData(true));
                        }
                    }, [validateForm, values, dirty]);
                    return (
                        <Form noValidate={true} className={"t-form"}>
                            <FormDebuggerComponent values={values} showDebugger={false}/>
                            <div className="t-form-controls">

                                <div className="medical-history-options-wrapper">
                                    {/*<div*/}
                                    {/*    className={'medical-history-options-heading'}>{commonService.capitalizeFirstLetter(letter) + " - Letter"}</div>*/}

                                    <div className={'ts-row mrg-left-10'}>
                                        {/*{index < medicalHistoryOptionsList?.length / 2 &&*/}
                                        {/*    <div className={'ts-col-md-6'} key={item._id}>*/}
                                        {/*        <Field*/}
                                        {/*            name={"medical_history.questions"}>*/}
                                        {/*            {(field: FieldProps) => (*/}
                                        {/*                <CheckBoxComponent*/}
                                        {/*                    id={'cb_' + item?.title}*/}
                                        {/*                    label={item?.title}*/}
                                        {/*                    checked={field.field?.value?.indexOf(item._id) > -1}*/}
                                        {/*                    onChange={() => {*/}
                                        {/*                        setFieldTouched(field.field?.name);*/}
                                        {/*                        setFieldValue(field.field?.name, handleMedicalHistoryOptionSelection(item._id, field.field?.value));*/}
                                        {/*                        validateForm();*/}
                                        {/*                    }}*/}
                                        {/*                />*/}
                                        {/*            )}*/}
                                        {/*        </Field>*/}
                                        {/*    </div>}*/}
                                        {/*{index > medicalHistoryOptionsList?.length / 2 &&*/}
                                        {/*    <div className={'ts-col-md-6'} key={item._id}>*/}
                                        {/*        <Field*/}
                                        {/*            name={"medical_history.questions"}>*/}
                                        {/*            {(field: FieldProps) => (*/}
                                        {/*                <CheckBoxComponent*/}
                                        {/*                    id={'cb_' + item?.title}*/}
                                        {/*                    label={item?.title}*/}
                                        {/*                    checked={field.field?.value?.indexOf(item._id) > -1}*/}
                                        {/*                    onChange={() => {*/}
                                        {/*                        setFieldTouched(field.field?.name);*/}
                                        {/*                        setFieldValue(field.field?.name, handleMedicalHistoryOptionSelection(item._id, field.field?.value));*/}
                                        {/*                        validateForm();*/}
                                        {/*                    }}*/}
                                        {/*                />*/}
                                        {/*            )}*/}
                                        {/*        </Field>*/}
                                        {/*    </div>*/}
                                        {/*}*/}
                                        <div className={'ts-col-md-6'}>
                                            {column1.map((item) => (

                                                <Field name="medical_history.questions">
                                                    {(field: FieldProps) => (
                                                        <CheckBoxComponent
                                                            id={'cb_' + item.title}
                                                            label={item.title}
                                                            checked={field.field?.value?.includes(item._id)}
                                                            onChange={() => {
                                                                setFieldTouched(field.field?.name);
                                                                setFieldValue(field.field?.name, handleMedicalHistoryOptionSelection(item._id, field.field?.value));
                                                                validateForm();
                                                            }}
                                                        />
                                                    )}
                                                </Field>

                                            ))}
                                        </div>
                                        <div className={'ts-col-md-6'}>
                                            {column2.map((item) => (
                                                <div key={item._id}>
                                                    <Field name="medical_history.questions">
                                                        {(field: FieldProps) => (
                                                            <CheckBoxComponent
                                                                id={'cb_' + item.title}
                                                                label={item.title}
                                                                checked={field.field?.value?.includes(item._id)}
                                                                onChange={() => {
                                                                    setFieldTouched(field.field?.name);
                                                                    setFieldValue(field.field?.name, handleMedicalHistoryOptionSelection(item._id, field.field?.value));
                                                                    validateForm();
                                                                }}
                                                            />
                                                        )}
                                                    </Field>
                                                </div>
                                            ))}
                                        </div>

                                    </div>
                                </div>

                                <div className="ts-row mrg-left-10">
                                    <div className="ts-col-md-6">
                                        <Field
                                            name={"medical_history.isCustomOption"}>
                                            {(field: FieldProps) => (
                                                <FormikCheckBoxComponent
                                                    formikField={field}
                                                    label={"Any other illnesses or conditions not listed above?"}
                                                    onChange={(isChecked) => {
                                                        if (!isChecked) {
                                                            setFieldValue('surgical_history.comments', "");
                                                            setFieldError('surgical_history.comments', undefined);
                                                            setTimeout(() => { // TODO solve fool proof
                                                                validateForm();
                                                            }, 10);
                                                        }
                                                    }}
                                                />
                                            )}
                                        </Field>
                                    </div>
                                </div>
                                {values.medical_history?.isCustomOption &&
                                    <div className="ts-row" id={"comments-field"}>
                                        <div className="ts-col-12">
                                            <Field name={`medical_history.comments`}>
                                                {
                                                    (field: FieldProps) => (
                                                        <FormikTextAreaComponent
                                                            rows={'5'}
                                                            placeholder={"Enter your comments here"}
                                                            disabled={!values.medical_history?.isCustomOption}
                                                            required={values.medical_history?.isCustomOption}
                                                            formikField={field}
                                                            fullWidth={true}
                                                            autoFocus={true}
                                                        />
                                                    )
                                                }
                                            </Field>
                                        </div>
                                    </div>}
                                <div className="t-form-actions">
                                    <ButtonComponent
                                        id={"next_btn"}
                                        size={'large'}
                                        type={"submit"}
                                        isLoading={isSubmitting}
                                        disabled={isSubmitting}
                                        suffixIcon={<ImageConfig.ArrowRightCircle/>}
                                    >
                                        {values?.medical_history?.questions?.length > 0 || values?.medical_history?.comments !== '' ? 'Next' : 'Skip'}
                                    </ButtonComponent>
                                </div>
                            </div>
                        </Form>
                    );
                }}
            </Formik>
        </div>
    );

};

export default ClientRegistrationMedicalHistoryMedicalHistoryComponent;
